<template>
  <div class='tooling sections'>
    <div class='tooling_content'>
      <h2>TOOLING</h2>
      <div class='description'>
        Any professional will tell you the importance of keeping their tools
        well maintained.  In technology, many of those tools are made of silicon or steel, but
        the most important tool is often less apparent - the mind.  Listed below are some
        of the tools I use both virtually and physically, as well as different areas I am working towards learning.

      </div>

      <h3>TECHNOLOGIES</h3>
      <div class='shell animated-scroll fade'>

        <div v-for="tech in json.technologies" class='tech_div'>
          <div class='tech_image'>
            <img :height="tech.img_height" :src="tech.icon" alt="Tech icon" />
          </div>
          <ul>
            <li v-for="item in tech.text" v-html="item">
            </li>
          </ul>
        </div>

      </div>
    </div>
    </div>
</template>

<script>
import json from '../../data/stack.json'
export default{

  name: "Tooling",
  data(){
    return{
      json: json
    }
  },

}
</script>
<style lang="scss">
/* Modern color palette */
$primary: #2563eb;
$dark: #1f2937;
$light-bg: #f9fafb;
/* Tooling page */
div.tooling {
    background-color: $light-bg;
    padding: 60px 20px;
}

div.tooling_content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

div.tooling_content div.description {
    width: 90%;
    max-width: 800px;
    margin: 0 auto;
    text-align: left;
    margin-top: 20px;
    margin-bottom: 50px;
    font-size: 1.125rem;
    line-height: 1.8;
    color: #4b5563;
}

div.tooling_content h3 {
    text-align: center;
    margin-top: 40px;
    margin-bottom: 40px;
    font-size: 1.75rem;
    font-weight: 700;
    color: $dark;
    letter-spacing: 0.5px;
}

div.tech_div {
    margin-top: 20px;
    margin-bottom: 20px;
    float: left;
    width: 30%;
    margin-left: 1.5%;
    margin-right: 1.5%;
    text-align: center;
    background-color: $bg-white;
    padding: 24px 20px;
    border: none;
    border-radius: $border-radius-md;
    box-shadow: $shadow-md;
    min-width: 250px;
    transition: all 0.3s ease;
}

@media screen and (max-width: 1024px) {
    div.tech_div {
        width: 46%;
        margin-left: 2%;
        margin-right: 2%;
    }
}

@media screen and (max-width: 640px) {
    div.tech_div {
        width: 90%;
        margin: 20px auto;
        float: none;
    }
}

div.tech_div:hover {
    transform: translateY(-6px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

div.tech_div ul {
    margin: auto;
    list-style-type: none;
    text-align: left;
    padding: 0;
}

div.tech_div ul li { 
    margin-top: 8px; 
    margin-bottom: 8px;
    color: $text-medium;
    font-size: 0.95rem;
    line-height: 1.6;
} 
 
div.tech_div div.tech_image { 
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
} 
 
.charts { 
        height: 150px !important; 
        width: 150px !important; 
        margin: auto; 
        margin-top: 20px; 
        margin-bottom: 20px; 
 
} 
 
.checked { 
        color: #2ABF70; 
} 
 
.pct_detail { 
        position: relative; 
        top: -103px; 
} 
 

</style>
